/**
 * Keeps server-generated links for a local development host on the currently
 * deployed portal. The API returns the route and query string we need, but a
 * misconfigured environment must not send beta or production users to their
 * own machine.
 */
export const getPortalRedirectUrl = (linkUrl: string): string => {
  try {
    const target = new URL(linkUrl, window.location.origin);
    const isCurrentHostLocal = window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1';
    const isTargetHostLocal = target.hostname === 'localhost' ||
      target.hostname === '127.0.0.1';

    if (!isCurrentHostLocal && isTargetHostLocal) {
      return `${window.location.origin}${target.pathname}${target.search}${target.hash}`;
    }

    return target.href;
  } catch {
    return linkUrl;
  }
};
